var _rect, _path, _path2, _circle, _path3, _path4, _path5, _ellipse, _ellipse2, _path6, _ellipse3, _path7, _path8, _circle2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyBackGuarantee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f1cf25",
    d: "M711.256 609.237s105.874 33.995 103.24 87.56c-3.261 66.614-69.246 75.81-124.148 54.903-54.863-20.908 20.908-142.463 20.908-142.463z",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1cf25",
    d: "M797.724 690.77c-1.926 3.38-4.088 6.564-6.563 9.55-3.302 3.97-7.153 7.546-11.672 10.533-9.59 6.366-20.75 10.06-32.07 11.986-25.308 4.284-51.954.393-75.14-10.571-1.77-.826-1.927-2.79-1.18-4.088l-1.375-.982c-1.926-1.415-3.891-2.79-5.817-4.166a496.335 496.335 0 00-56.199-33.798c-20.24-10.336-40.832-19.964-61.308-29.829-.04 1.337-.118 2.673-.196 4.009a1095.037 1095.037 0 01-13.166 121.476c2.24.708 3.184 4.205.433 5.03-19.297 5.974-38.632 11.909-57.929 17.882-16.702 5.148-33.365 10.65-50.264 15.091-16.939 4.441-34.23 6.406-51.483 9.275-29.082 4.795-56.867 15.917-85.989 20.2-2.122 10.454-4.048 20.908-5.973 31.401-4.795 25.977-9.629 51.994-17.646 77.225-6.956 21.89-16.27 43.898-31.794 61.19-14.737 16.388-35.252 27.628-57.653 27.746-3.419 0-6.76-.276-10.06-.865-5.7-.983-11.123-2.869-16.153-5.502-6.052-5.817-11.161-12.694-15.13-20.161a90.114 90.114 0 01-4.874-10.886c-7.82-21.497-8.135-44.763-6.995-67.36 2.515-48.693 10.218-97.071 22.008-144.35 5.934-23.776 12.812-47.434 21.104-70.464 3.851-10.729 8.253-21.222 13.912-31.086 5.424-9.511 12.144-18.157 19.807-25.978 14.934-15.366 49.636-42.208 65.985-55.884 74.434-62.29 178.815-96.993 188.404-103.634 9.157-6.328 19.493-10.965 30.38-13.245 22.125-4.637 45.744-.786 66.495 7.625 5.502 2.24 10.886 4.834 16.034 7.82 42.64 24.877 194.653 131.577 213.36 148.672 10.847 9.904 16.349 22.401 18.078 35.095.59 3.694.747 7.389.629 11.043z",
    vectorEffect: "non-scaling-stroke"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 23.11,
    fill: "#f1cf25",
    transform: "matrix(3.93 0 0 3.93 517.28 690.9)",
    vectorEffect: "non-scaling-stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M548.06 635.549c-4.717-6.406-14.424-8.764-21.183-5.188-18.825 9.983-86.578 39.772-87.325 40.086-11.083 5.07-19.847 14.03-24.76 25.192l-29.12 66.535-39.458 29.75a2.01 2.01 0 00-.786 1.454c-.039.59.197 1.14.63 1.532l60.757 56.868c.393.353.865.51 1.336.51s.943-.157 1.297-.51l17.724-15.76 24.013-23.619c2.476.079 10.69-.432 24.287-5.345 7.192-2.594 13.284-8.489 18.039-14.54.118.078.236.156.353.196 2.909.864 5.62 1.257 8.136 1.257 16.663 0 25.152-16.82 27.588-22.636 3.262-7.86 4.48-22.166-2.004-31.362h.04c.864 0 1.69-.59 1.886-1.493.235-.904 5.62-22.362-5.777-30.89-1.1-.825-2.437-1.258-3.852-1.533.197-.157.393-.314.55-.59.158-.353 4.127-8.842-7.545-21.182-1.887-1.965-4.402-2.947-7.31-3.301 11.358-5.345 30.89-14.973 36.667-20.75 12.497-12.459 8.213-21.42 5.816-24.681z",
    vectorEffect: "non-scaling-stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M502.588 499.769c36.038-29.986 57.417-127.136 57.417-148.711 0-7.585-.786-14.974-2.279-22.087-.354-2.947-1.1-5.777-2.122-8.489-12.615-42.562-50.894-73.53-96.128-73.53-32.462 0-69.05 65.238-93.848 119.511a47.853 47.853 0 00-11.947-1.532c-26.96 0-48.772 21.85-48.772 48.81 0 18.982 19.257 40.519 51.365 40.126l-28.61 115.424c-57.968 37.295-117.743 80.486-107.21 101.354 13.244 26.331 94.084 12.42 180.544-31.125 86.46-43.545 145.763-100.176 132.52-126.507-4.284-8.332-15.21-12.615-30.93-13.244z",
    vectorEffect: "non-scaling-stroke"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M652.122 787.874h-93.101c-13.284 0-20.122-10.768-15.288-24.012l62.448-171.545c4.834-13.244 19.493-24.012 32.776-24.012h93.102c13.283 0 20.121 10.768 15.287 24.012L684.9 763.862c-4.834 13.244-19.493 24.012-32.777 24.012zM557.65 331.9a37.694 37.694 0 00-2.2-8.764c-13.048-44.055-53.016-81.665-99.548-76.085-70.582 8.49-97.817 77.225-109.214 122.066 26.96.157 48.889 21.458 50.068 48.182 29.082-.197 61.19-7.113 92.748-21.34 27.864-12.576 51.758-29.279 70.308-47.946-.354-5.541-1.062-10.886-2.162-16.113z",
    vectorEffect: "non-scaling-stroke"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 25.05,
    ry: 37.47,
    transform: "matrix(1.37 -3.68 3.68 1.37 321.49 193.43)",
    vectorEffect: "non-scaling-stroke"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    rx: 25.05,
    ry: 37.47,
    transform: "matrix(1.37 -3.68 3.68 1.37 307.53 207.36)",
    vectorEffect: "non-scaling-stroke"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M502.32 499.556c-22.205 22.204-58.793 49.675-75.81 49.675-35.527 0-43.23-76.242-43.23-76.242",
    vectorEffect: "non-scaling-stroke"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.34,
    ry: 2.07,
    transform: "matrix(1.34 -3.69 3.69 1.34 473.16 430.11)",
    vectorEffect: "non-scaling-stroke"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M529.624 424.161c2.475-6.799 1.06-13.559-3.184-15.091-4.244-1.533-9.668 2.75-12.144 9.55-2.475 6.799-1.06 13.558 3.184 15.09 4.205 1.534 9.668-2.71 12.144-9.549z",
    vectorEffect: "non-scaling-stroke"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M536.24 385.367c-8.567-2.397-17.999 1.69-23.933 8.332s-8.921 15.405-10.886 24.09a130.441 130.441 0 00-2.908 36.432c.235 3.772.59 7.781-1.062 11.16-1.65 3.42-6.248 5.7-9.353 3.499m-36.824 15.051c4.087 6.092 11.908 9.472 19.178 8.175M344.34 388.51c13.362 9.078 19.61 27.314 14.659 42.68",
    vectorEffect: "non-scaling-stroke"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 27.27,
    fill: "#141f2e",
    transform: "rotate(-76.7 624.927 -373.682) scale(6.32)",
    vectorEffect: "non-scaling-stroke"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M651.815 629.76c-2.869 8.842.236 17.763 6.917 19.885 6.68 2.162 14.383-3.301 17.213-12.144 2.869-8.842-.236-17.763-6.917-19.885-6.68-2.123-14.384 3.3-17.213 12.143z",
    vectorEffect: "non-scaling-stroke"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M673.552 755.559l32.07 5.227c6.759 1.257 13.636-5.463 15.405-15.013h0c1.768-9.55-2.28-18.274-9-19.532l-32.069-5.227c-6.76-1.257-13.637 5.463-15.405 15.013h0c-1.769 9.55 2.279 18.314 9 19.532z",
    vectorEffect: "non-scaling-stroke"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M677.918 725.138l33.758 6.249c9.55 1.768 18.707-4.52 20.436-14.07h0c1.769-9.55-4.52-18.706-14.069-20.436l-33.759-6.248c-9.55-1.769-18.706 4.52-20.436 14.069h0c-1.768 9.51 4.52 18.668 14.07 20.436z",
    vectorEffect: "non-scaling-stroke"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M686.838 695.599l33.758 6.248c9.55 1.769 18.707-4.52 20.436-14.069h0c1.769-9.55-4.52-18.707-14.069-20.436l-33.759-6.249c-9.55-1.768-18.706 4.52-20.436 14.07h0c-1.729 9.51 4.56 18.667 14.07 20.436z",
    vectorEffect: "non-scaling-stroke"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M692.226 663.865L736.085 672c6.76 1.257 13.637-5.463 15.405-15.013h0c1.769-9.55-7.192-52.387-13.912-53.645l-9.786 31.401-29.16-5.423c-6.76-1.258-13.637 5.462-15.406 15.012h0c-1.808 9.55 2.24 18.275 9 19.533z",
    vectorEffect: "non-scaling-stroke"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M672.095 358.455h-3.93v3.93",
    vectorEffect: "non-scaling-stroke"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "2.062 4.123",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M668.16 378.576v137.708",
    vectorEffect: "non-scaling-stroke"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M668.16 524.345v3.93",
    vectorEffect: "non-scaling-stroke"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M496.4 683.047s36.47-16.23 44.448-24.17c19.61-19.61-1.965-32.657-13.087-26.802-19.1 10.14-87.403 40.125-87.403 40.125-10.611 4.874-19.06 13.48-23.777 24.21l-29.317 67.006-39.85 30.064",
    vectorEffect: "non-scaling-stroke"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M460.698 701.184s39.615-27.274 50.737-15.524c10.846 11.476 7.192 18.943 7.192 18.943m-38.79 22.283s32.266-25.545 42.72-17.685c10.453 7.86 5.03 28.846 5.03 28.846",
    vectorEffect: "non-scaling-stroke"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M492.358 749.547S517 730.92 524.663 739.33c7.663 8.41 6.288 23.541 3.104 31.283-3.262 7.86-13.637 26.135-33.326 20.24",
    vectorEffect: "non-scaling-stroke"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M502.302 774.505s-11.122 24.837-27.431 30.693c-16.35 5.895-24.406 5.188-24.406 5.188l-24.601 24.209-17.646 15.68",
    vectorEffect: "non-scaling-stroke"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M276.24 948.92s90.193-40.518 134.602-87.56",
    vectorEffect: "non-scaling-stroke"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1cf25",
    d: "M174.899 1029.927c45.627 13.991 217.8-148.436 235.564-175.081 1.73-2.633-67.085-61.858-67.085-61.858s-80.172 27.863-125.446 81.036c-45.352 53.134-90.35 141.402-43.033 155.903z",
    vectorEffect: "non-scaling-stroke"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M339.01 796.039s-84.966 36.588-118.92 70.582m73.177-104.527s-7.86 44.448-18.314 66.652",
    vectorEffect: "non-scaling-stroke"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fffbfb",
    d: "M788.772 315.878c-.302 9.513 4.452 13.726 4.57 16.401a3.429 3.429 0 01-1.722 2.634l-5.376 3.763a4.477 4.477 0 01-2.365.806c-.18-.008-3.44.769-8.601-10.756a33.015 33.015 0 01-26.297 12.37c-6.837.373-25.368-3.882-24.414-23.609-.668-16.078 14.305-26.065 29.79-25.221 2.982.008 9.072.155 19.736 2.633v-6.56c1.13-11.113-6.174-19.736-18.82-18.442-1.008.004-8.148-.21-19.253 4.246-3.091 1.42-3.486 1.184-4.515 1.184-3.112 0-1.831-9.021-1.235-10.164 2.189-2.688 15.062-7.707 27.695-7.635a32.28 32.28 0 0123.39 7.257 29.52 29.52 0 017.421 21.992l-.004 29.101zm-36.296 13.604c13.62-.197 19.387-8.387 20.702-12.797 1.033-4.221.86-6.892.86-11.508-4.06-.975-9.907-2.037-16.615-2.046-6.363-.478-17.984 2.365-17.53 13.55-.521 7.051 4.67 13.188 12.583 12.801zm71.786 9.681c-3.301.303-4.838-2.041-5.325-4.355l-20.916-69.153a16.043 16.043 0 01-.807-3.604 1.936 1.936 0 011.621-2.205c.101-.017-.894 0 9.345 0 3.688-.37 4.89 2.533 5.271 4.356l15.003 59.148 13.927-59.148c.223-1.353 1.235-4.65 5.376-4.301h7.207c.912-.076 4.666-.21 5.326 4.355l14.036 59.905 15.486-59.905c.201-.915 1.142-4.775 5.325-4.355h8.283c.357-.055 2.583-.34 2.205 3.603-.181.777 1.432-4.477-22.155 71.358-.483 2.315-2.025 4.658-5.326 4.356h-7.85c-4.595.483-5.254-4.057-5.325-4.515l-13.928-57.595-13.767 57.536c-.067.458-.727 4.998-5.326 4.515h-7.686zm114.862 2.365c-2.47.004-14.247-.126-24.091-5.162a5.377 5.377 0 01-3.28-5.002v-4.515c0-3.55 2.603-2.898 3.708-2.474 4.217 1.705 6.922 2.999 12.1 4.032 15.393 3.163 22.164-.966 23.823-1.882 5.523-3.28 5.96-10.785 2.205-14.679-4.402-3.691-6.502-3.83-22.315-8.82-1.949-.541-18.354-5.716-18.392-21.99-.256-11.862 10.521-23.596 29.199-23.5 5.321-.004 19.5 1.735 23.339 6.56.567.878.848 1.912.806 2.957v4.247c0 1.864-.68 2.797-2.045 2.797-3.238-.361-8.984-4.692-20.647-4.515-2.894-.151-16.754.382-16.132 10.487-.181 7.963 11.176 10.95 12.474 11.294 15.313 4.607 20.433 5.372 26.51 12.424 7.199 9.345 3.318 20.286 1.827 23.284-8.014 15.746-28.736 14.465-29.09 14.457zm16.884 44.041c-29.413 21.722-72.11 33.285-108.566 33.285a197.033 197.033 0 01-133.253-50.707c-2.743-2.473-.324-5.863 3.011-3.977a267.695 267.695 0 00133.09 35.33 264.692 264.692 0 00101.467-20.81c4.948-2.1 9.144 3.275 4.25 6.879zm12.26-13.982c-3.764-4.838-24.898-2.26-34.36-1.13-2.852.324-3.335-2.15-.752-3.977 16.829-11.831 44.47-8.442 47.644-4.465 3.171 3.978-.86 31.673-16.615 44.903-2.419 2.045-4.733.966-3.658-1.722 3.545-8.925 11.504-28.766 7.74-33.609z",
    vectorEffect: "non-scaling-stroke"
  })));
}
export default __webpack_public_path__ + "static/Money-back-guarantee.277d5fc8.svg";
export { SvgMoneyBackGuarantee as ReactComponent };